import { useTranslation } from 'react-i18next';
import { PostModal } from '../shared';
import { Template, TemplatePostDetailsType } from './template';

export type InstagramInteractionTaggedPostDetailsModalProps = Pick<
  React.ComponentProps<typeof PostModal<TemplatePostDetailsType>>,
  'posts'
>;

export const InstagramInteractionTaggedPostDetailsModal = ({
  posts
}: InstagramInteractionTaggedPostDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={posts}>
      <PostModal.Title>{t('Post Detail')}</PostModal.Title>
      <Template />
    </PostModal>
  );
};
